import { createContext, useContext } from 'react'

export const OverallKbaCriteriaRefreshContext = createContext({
  refetchCriteria: () => {}
})

export const useOverallKbaCriteriaRefresh = () => {
  return useContext(OverallKbaCriteriaRefreshContext)
}
